import { styled, TextField, TextFieldProps } from "@mui/material";
import { THEME_COLORS } from "../../context/constants";

const StyledWhiteTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputLabel-root": {
    color: "black",
    "&.Mui-focused": {
      color: THEME_COLORS.yellow, // Highlight when focused
    },
  },
  "& .MuiOutlinedInput-root": {
    color: "black",
    "& fieldset": {
      borderColor: "rgba(48, 41, 41, 0.23)",
    },
    "&:hover fieldset": {
      borderColor: "black",
    },
    "&.Mui-focused fieldset": {
      borderColor: THEME_COLORS.yellow, // Highlight border when focused
    },
  },
  "& .MuiInputBase-input": {
    color: "black",
  },
  "& .MuiFormHelperText-root": {
    color: "black", // Optional: style helper text
  },
}));

export const WhiteTextField = (props: TextFieldProps) => {
  return (
    <StyledWhiteTextField
      {...props}
      InputLabelProps={{
        ...props.InputLabelProps,
        shrink: true, // Ensures label doesn't overlap with value
      }}
    />
  );
};
